import React, { useEffect, useState } from "react";
import { Clock } from "lucide-react";

/**
 * Live countdown to a future timestamp. Hidden if expired or no target.
 * Returns null gracefully if `to` is missing/invalid.
 */
function fmt(n) {
  return String(Math.max(0, n)).padStart(2, "0");
}

export default function Countdown({ to, compact = false, label = "Scade tra" }) {
  const target = to ? new Date(to).getTime() : null;
  const [now, setNow] = useState(() => Date.now());

  useEffect(() => {
    if (!target) return;
    const t = setInterval(() => setNow(Date.now()), 1000);
    return () => clearInterval(t);
  }, [target]);

  if (!target || isNaN(target)) return null;
  const diff = Math.max(0, target - now);
  if (diff <= 0) return null;

  const totalSeconds = Math.floor(diff / 1000);
  const days = Math.floor(totalSeconds / 86400);
  const hours = Math.floor((totalSeconds % 86400) / 3600);
  const minutes = Math.floor((totalSeconds % 3600) / 60);
  const seconds = totalSeconds % 60;

  const urgent = diff < 1000 * 60 * 60 * 6; // < 6h

  if (compact) {
    return (
      <div
        data-testid="countdown-compact"
        className={`inline-flex items-center gap-1 font-mono-bdd text-[10px] font-bold px-2 py-1 rounded-md ${
          urgent
            ? "bg-rose-600/20 text-rose-300 border border-rose-700/50"
            : "bg-[#FBD51C]/15 text-[#FBD51C] border border-[#FBD51C]/30"
        }`}
      >
        <Clock size={10} />
        {days > 0 ? `${days}g ${fmt(hours)}h` : `${fmt(hours)}:${fmt(minutes)}:${fmt(seconds)}`}
      </div>
    );
  }

  return (
    <div data-testid="countdown" className="inline-flex items-center gap-2">
      <div className={`flex items-center gap-1 text-[10px] uppercase tracking-[0.2em] font-bold ${urgent ? "text-rose-400" : "text-[#FBD51C]"}`}>
        <Clock size={12} /> {label}
      </div>
      <div className="font-mono-bdd font-black text-white text-base">
        {days > 0 && <span>{days}g </span>}
        {fmt(hours)}<span className="text-[#6e7896]">:</span>{fmt(minutes)}<span className="text-[#6e7896]">:</span>{fmt(seconds)}
      </div>
    </div>
  );
}
